import { useEnv } from '@sparklayer-io/spark-dash-core/context/env-context';
import { t } from 'i18next';
import upgrade1Img from '../../../assets/upgrade-1.png';
import upgrade2Img from '../../../assets/upgrade-2.png';
import upgrade3Img from '../../../assets/upgrade-3.png';
import upgrade5Img from '../../../assets/upgrade-5.png';
import upgrade6Img from '../../../assets/upgrade-6.png';
import type { I18nPrefix } from '../../../i18n/prefix';
import { Upsell, type UpsellItem } from './upsell';

const COMPONENT = 'features:home.components.upsell_plan' satisfies I18nPrefix;

export function UpsellPlan() {
  const env = useEnv();
  const plan = env.billing.plan_key;

  const items: UpsellItem[] = [
    {
      title: t(`${COMPONENT}.sales_agents.title`),
      image: upgrade1Img,
      description: t(`${COMPONENT}.sales_agents.description`),
      link: 'https://docs.sparklayer.io/sales-agent-ordering',
      needsUpgrade: plan === 'basic_free',
      badge: 'starter',
      action: '/sales-agents',
    },
    {
      title: t(`${COMPONENT}.invoices.title`),
      image: upgrade5Img,
      description: t(`${COMPONENT}.invoices.description`),
      link: 'https://docs.sparklayer.io/invoices',
      needsUpgrade: plan === 'v2_basic',
      badge: 'growth',
      action: '/configuration/general',
    },
    {
      title: t(`${COMPONENT}.quoting.title`),
      image: upgrade6Img,
      description: t(`${COMPONENT}.quoting.description`),
      link: 'https://docs.sparklayer.io/quoting',
      needsUpgrade: plan === 'v2_basic',
      badge: 'pro',
      action: '/configuration/general',
    },
    {
      title: t(`${COMPONENT}.company_users.title`),
      image: upgrade2Img,
      description: t(`${COMPONENT}.company_users.description`),
      link: 'https://docs.sparklayer.io/company-users',
      needsUpgrade: plan === 'v2_basic' || plan === 'v2_growth',
      badge: 'pro',
      action: '/configuration/general',
      className: 'hidden 2xl:block',
    },
    {
      title: t(`${COMPONENT}.api_access.title`),
      image: upgrade3Img,
      description: t(`${COMPONENT}.api_access.description`),
      link: 'https://docs.sparklayer.io/sparklayer-api',
      needsUpgrade: plan === 'v2_basic' || plan === 'v2_growth',
      badge: 'pro',
      action: '/configuration/api',
    },
  ];

  return <Upsell items={items} />;
}
